// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Cflf","newExpiryDate":"styles_newExpiryDate__1IzK_","footer":"styles_footer__eFWyN"};